/** This export is automatically generated */
export const isoNow = '2025-04-23T09:13:27.849Z';
